import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useSelectorLocations = () => {
  const locations = useSelector((state: RootState) => {
    return state.locations.locations;
  });
  if (!locations) return [];
  return locations;
};
